import { render } from "./AccountNumberDescription.vue?vue&type=template&id=77718e46&scoped=true"
import script from "./AccountNumberDescription.vue?vue&type=script&lang=js"
export * from "./AccountNumberDescription.vue?vue&type=script&lang=js"

import "./AccountNumberDescription.vue?vue&type=style&index=0&id=77718e46&scoped=true&lang=css"

import exportComponent from "C:\\chuning\\cn-page\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77718e46"]])

export default __exports__